export const userError = {
  login_user_001: 'UCE|LU-001',
  login_user_002: 'UCE|LU-002',
  login_user_003: 'UCE|LU-003',
  update_user_001: 'UCE|UU-001',
  update_user_002: 'UCE|UU-002',
  update_user_avatar_001: 'UCE|UUA-001',
  update_user_avatar_002: 'UCE|UUA-002',
  delete_user_001: 'UCE|DU-001',
  update_language_001: 'UCE|UL-001',
  update_language_002: 'UCE|UL-002',
};

export const companyError = {
  getCompanyData_001: 'UCE|GCD-001',
  update_company_001: 'UCE|UC-001',
  update_company_002: 'UCE|UC-002',
  update_company_003: 'UCE|UC-003',
  update_company_logo_001: 'UCE|UCL-001',
  update_company_logo_002: 'UCE|UCL-002',
  updateSocialMedia_001: 'UCE|USM-001',
  updateSocialMedia_002: 'UCE|USM-002',
  removeSocialMedia_001: 'UCE|RSM-001',
  removeSocialMedia_002: 'UCE|RSM-002',
  selectCompanySuperAdmin_001: 'UCE|SCS-001',
  selectCompanySuperAdmin_002: 'UCE|SCS-002',
  selectCompanySuperAdmin_003: 'UCE|SCS-003',
};

export const dashboardError = {
  get_dashboard_001: 'DE|GD-001',
};

export const mainContactError = {
  get_contacts_001: 'MCE|GC-001',
  get_contacts_002: 'MCE|GC-002',
  create_contact_001: 'MCE|CC-001',
  create_contact_002: 'MCE|CC-002',
  update_contact_001: 'MCE|UC-001',
  update_contact_002: 'MCE|UC-002',
  update_contact_003: 'MCE|UC-003',
  update_contact_004: 'MCE|UC-004',
  remove_contact_001: 'MCE|RC-001',
  remove_contact_002: 'MCE|RC-002',
};

export const commercialInfoError = {
  get_commercial_info_001: 'CIE|GCI-001',
  create_commercial_info_001: 'CIE|CCI-001',
  create_commercial_info_002: 'CIE|CCI-002',
  select_commercial_info_001: 'CIE|SCI-001',
  update_commercial_info_001: 'CIE|UCI-001',
  update_commercial_info_002: 'CIE|UCI-002',
  remove_commercial_agent_001: 'CIE|RCA-001',
  remove_commercial_agent_002: 'CIE|RCA-002',
};

export const brandUsersError = {
  get_brand_users_001: 'BUE|GBU-001',
  create_brand_user_001: 'BUE|CBU-001',
  create_brand_user_002: 'BUE|CBU-002',
  update_brand_user_001: 'BUE|UBU-001',
  update_brand_user_002: 'BUE|UBU-002',
  update_brand_user_003: 'BUE|UBU-003',
  update_brand_user_004: 'BUE|UBU-004',
  update_brand_user_005: 'BUE|UBU-005',
  update_brand_user_006: 'BUE|UBU-006',
};

export const multimediaError = {
  get_multimedia_001: 'MME|GM-001',
  get_more_multimedia_001: 'MME|GMM-001',
  create_multimedia_001: 'MME|CIM-001',
  create_multimedia_002: 'MME|CIM-002',
  create_multimedia_003: 'MME|CIM-003',
  create_multimedia_004: 'MME|CIM-004',
  update_multimedia_001: 'MME|UIM-001',
  update_multimedia_002: 'MME|UIM-002',
  remove_multimedia_001: 'MME|RIM-001',
  remove_multimedia_002: 'MME|RIM-002',
  // select_multimedia_001: 'MME|RIM-001',
  search_multimedia_001: 'MME|SM-001',
};

export const catalogError = {
  get_catalog_001: 'CE|GC-001',
  getProduct_001: 'CE|GP-001',
  getProduct_002: 'CE|GP-002',
  add_more_products_to_catalog_001: 'CE|AMPTC-001',
  search_catalog_001: 'CE|SC-001',
  filter_catalog_001: 'CE|FC-001',
  addLike_001: 'CE|AL-001',
  addLike_002: 'CE|AL-002',
  removeLike_001: 'CE|RL-001',
  removeLike_002: 'CE|RL-002',
};

export const clientsError = {
  getClients_001: 'CLE|GC-001',
  getClients_002: 'CLE|GC-002',
  getCategories_001: 'CLE|GCC-001',
  getCategories_002: 'CLE|GCC-002',
  selectClient_001: 'CLE|SC-001',
  createClient_001: 'CLE|CC-001',
  createClient_002: 'CLE|CC-002',
  updateClient_001: 'CLE|UC-001',
  updateClient_002: 'CLE|UC-002',
  deleteClient_001: 'CLE|DC-001',
  deleteClient_002: 'CLE|DC-002',
  accept_association_001: 'CLE|AA-001',
  accept_association_002: 'CLE|AA-002',
  reject_association_001: 'CLE|RA-001',
  reject_association_002: 'CLE|RA-002',
  accept_ps_association_001: 'CLE|APSA-001',
  reject_ps_association_001: 'CLE|RPSA-001',
  reject_ps_association_002: 'CLE|RPSA-002',
  get_exchanges_001: 'CLE|GE-001',
  get_exchanges_002: 'CLE|GE-002',
  get_segmentations_001: 'CLE|GS-001',
  get_segmentations_002: 'CLE|GS-002',
  add_exchange_rate_001: 'CLE|AER-001',
  add_exchange_rate_002: 'CLE|AER-002',
  update_exchange_rate_001: 'CLE|UER-001',
  update_exchange_rate_002: 'CLE|UER-002',
};

export const commercialProfileError = {
  init_bio_001: 'CPE|IB-001',
  init_bio_002: 'CPE|IB-002',
  update_bio_001: 'CPE|UB-001',
  update_bio_002: 'CPE|UB-002',
};

export const catalogGenericsError = {
  get_generics_001: 'GE|GG-001',
  get_generics_002: 'GE|GG-002',
  add_generics_001: 'GE|AG-001',
  add_generics_002: 'GE|AG-002',
  update_generics_001: 'GE|UG-001',
  update_generics_002: 'GE|UG-002',
};

export const catalogCorrelationsError = {
  get_correlations_001: 'CE|GC-001',
  get_correlations_002: 'CE|AC-002',
  assign_generics_001: 'AG|AG-001',
  assign_generics_002: 'AG|AG-002',
};

export const catalogCSVUpload = {
  get_report_by_upload_001: 'CSV|GRBU-001',
  publish_upload_001: 'CSV|PU-001',
  reject_upload_001: 'CSV|RU-001',
  reject_upload_002: 'CSV|RU-002',
  get_reports_by_season_001: 'CSV|GRBS-001',
  set_start_season_date_001: 'CSV|SSSD-001',
  set_start_season_date_002: 'CSV|SSSD-002',
  set_end_season_date_001: 'CSV|SESD-001',
  set_end_season_date_002: 'CSV|SESD-002',
  enable_season_001: 'CSV|ES-001',
  enable_season_002: 'CSV|ES-002',
};

export const metaError = {
  // Connections
  get_connections_001: 'ME|GC-001',
  // Map fields
  get_map_fields_001: 'ME|GMF-001',
  create_map_field_001: 'ME|CMF-001',
  create_map_field_002: 'ME|CMF-002',
  update_map_field_001: 'ME|UMF-001',
  update_map_field_002: 'ME|UMF-002',
  add_field_to_map_001: 'ME|AFM-001',
  // create_map_field_003: 'ME|CMF-003',
  // create_map_field_004: 'ME|CMF-004',
  // create_map_field_005: 'ME|CMF-005',
  delete_map_field_001: 'ME|DMF-001',
  delete_map_field_002: 'ME|DMF-002',
  delete_map_fields_001: 'ME|DMFS-001',
  delete_map_fields_002: 'ME|DMFS-002',
  // // Map fields temp0lates
  get_map_fields_templates_001: 'ME|GMFT-001',
  // get_shopify_queries_001: 'ME|GSQ-001',
  // create_map_fields_template_001: 'ME|CMFT-001',
  // create_map_fields_template_002: 'ME|CMFT-002',
  delete_map_field_template_001: 'ME|DMFT-001',
  delete_map_field_template_002: 'ME|DMFT-002',
  copy_map_fields_template_001: 'ME|CMFT-001',
  copy_map_fields_template_002: 'ME|CMFT-002',

  // SFTP
  delete_sftp_connection_001: 'ME|DSC-001',
  delete_sftp_connection_002: 'ME|DSC-002',
  create_sftp_connection_001: 'ME|CSC-001',
  create_sftp_connection_002: 'ME|CSC-002',
  update_sftp_connection_001: 'ME|USC-001',
  update_sftp_connection_002: 'ME|USC-002',
  // Shopify
  create_shopify_connection_001: 'ME|CSHC-001',
  create_shopify_connection_002: 'ME|CSHC-002',
  create_shopify_connection_003: 'ME|CSHC-003',
  create_shopify_connection_004: 'ME|CSHC-004',
  update_shopify_connection_001: 'ME|USC-001',
  update_shopify_connection_002: 'ME|USC-002',
  delete_shopify_connection_001: 'ME|DSC-001',
  delete_shopify_connection_002: 'ME|DSC-002',
  // Configuration
  get_shopify_configuration_001: 'ME|GSC-001',
  create_update_shopify_configuration_001: 'ME|CUSC-001',
  create_update_shopify_configuration_002: 'ME|CUSC-002',
  // Maps
  get_maps_001: 'ME|GM-001',
  create_map_001: 'ME|CM-001',
  create_map_002: 'ME|CM-002',
  create_map_003: 'ME|CM-003',
  create_map_004: 'ME|CM-004',
  delete_map_001: 'ME|DM-001',
  delete_map_002: 'ME|DM-002',
  update_map_001: 'ME|UM-001',
  update_map_002: 'ME|UM-002',
  add_map_to_connector_001: 'ME|AMTC-001',
  add_map_to_connector_002: 'ME|AMTC-002',
  delete_map_from_connector_001: 'ME|DMFC-001',
  delete_map_from_connector_002: 'ME|DMFC-002',
  add_map_fields_to_map_001: 'ME|AMFTM-001',
  add_map_fields_to_map_002: 'ME|AMFTM-002',
  // Queries
  get_shopify_queries_001: 'ME|GSQ-001',
  create_shopify_query_001: 'ME|CSQ-001',
  create_shopify_query_002: 'ME|CSQ-002',
  delete_shopify_query_001: 'ME|DSQ-001',
  delete_shopify_query_002: 'ME|DSQ-002',
  update_shopify_query_001: 'ME|USQ-001',
  update_shopify_query_002: 'ME|USQ-002',
  get_shopify_templates_001: 'ME|GST-001',
  create_update_shopify_template_001: 'ME|CUST-001',
  create_update_shopify_template_002: 'ME|CUST-002',
  delete_shopify_template_001: 'ME|DST-001',
  delete_shopify_template_002: 'ME|DST-002',
  remove_map_field_from_map_001: 'ME|RMFFM-001',
  remove_map_field_from_map_002: 'ME|RMFFM-002',
  remove_map_fields_from_map_001: 'ME|RMFFM-001',
  remove_map_fields_from_map_002: 'ME|RMFFM-002',
};

export const superAdminError = {
  get_map_fields_001: 'ME|GMF-001',
  create_map_field_001: 'ME|CMF-001',
  create_map_field_002: 'ME|CMF-002',
  create_map_field_003: 'ME|CMF-003',
  create_map_field_004: 'ME|CMF-004',
  create_map_field_005: 'ME|CMF-005',
  update_map_field_001: 'ME|UMF-001',
  update_map_field_002: 'ME|UMF-002',
  delete_map_field_001: 'ME|DMF-001',
  delete_map_field_002: 'ME|DMF-002',
  // Map fields temp0lates
  get_map_fields_templates_001: 'ME|GMFT-001',
  get_shopify_queries_001: 'ME|GSQ-001',
  create_map_fields_template_001: 'ME|CMFT-001',
  create_map_fields_template_002: 'ME|CMFT-002',
  delete_map_field_template_001: 'ME|DMFT-001',
  delete_map_field_template_002: 'ME|DMFT-002',
  // Queries
  create_shopify_query_001: 'ME|CSQ-001',
  create_shopify_query_002: 'ME|CSQ-002',
  delete_shopify_query_001: 'ME|DSQ-001',
  delete_shopify_query_002: 'ME|DSQ-002',
  update_shopify_query_001: 'ME|USQ-001',
  update_shopify_query_002: 'ME|USQ-002',
  get_shopify_templates_001: 'ME|GST-001',
  create_update_shopify_template_001: 'ME|CUST-001',
  create_update_shopify_template_002: 'ME|CUST-002',
  delete_shopify_template_001: 'ME|DST-001',
  delete_shopify_template_002: 'ME|DST-002',
};

export const commercialAgentsError = {
  getCommercialAgents_001: 'CAE|GCA-001',
  getCommercialAgents_002: 'CAE|GCA-002',
  createCommercialAgent_001: 'CAE|CCA-001',
  createCommercialAgent_002: 'CAE|CCA-002',
  createCommercialAgent_003: 'CAE|CCA-003',
  createCommercialAgent_004: 'CAE|CCA-004',
  updateCommercialAgent_001: 'CAE|UCA-001',
  updateCommercialAgent_002: 'CAE|UCA-002',
  updateCommercialAgent_003: 'CAE|UCA-003',
  updateCommercialAgent_004: 'CAE|UCA-004',
  updateCommercialAgent_005: 'CAE|UCA-005',
  updateCommercialAgent_006: 'CAE|UCA-006',
  deleteCommercialAgent_001: 'CAE|DCA-001',
  deleteCommercialAgent_002: 'CAE|DCA-002',
  assignAgentsToClient_001: 'CAE|AATC-001',
};

export const catalogUpdateReferencesError = {
  getCatalogItemsAction_001: 'CURE|GCI-001',
  getFiltersAction_001: 'CURE|GFA-001',
  getFiltersAction_002: 'CURE|GFA-002',
  searchOnCatalogItemsAction_001: 'CURE|SCA-001',
  updateReferencesAction_001: 'CURE|URA-001',
  updateReferencesAction_002: 'CURE|URA-002',
  handlePaginationAction_001: 'CURE|HPA-001',
};

export const salesMatchingError = {
  getSalesMatchingAction_001: 'CURE|GSI-001',
  searchOnCatalogItemsAction_001: 'CURE|SCA-001',
  handlePaginationAction_001: 'CURE|HPA-001',
  getReferencesOptionsAction_001: 'CURE|GRO-001',
  getReferencesOptionsAction_002: 'CURE|GRO-002',
  getReferencesOptionsAction_003: 'CURE|GRO-003',
  addToSalesMatchingToUpdateReferenceAction_001: 'CURE|ATSMUR-001',
  addToSalesMatchingToUpdateReferenceAction_002: 'CURE|ATSMUR-002',
  addToSalesMatchingToUpdateReferenceAction_003: 'CURE|ATSMUR-003',
  addToSalesMatchingToUpdateColorAction_001: 'CURE|ATSMUC-001',
  addToSalesMatchingToUpdateColorAction_002: 'CURE|ATSMUC-002',
  addToSalesMatchingToUpdateSizeAction_001: 'CURE|ATSMUS-001',
  addToSalesMatchingToUpdateSkuAction_001: 'CURE|ATSMUSK-001',
  matchSaleAction_001: 'CURE|MSA-001',
  matchSaleAction_002: 'CURE|MSA-002',
  matchSaleAction_003: 'CURE|MSA-003',
  matchSaleAction_004: 'CURE|MSA-004',
  matchSaleActionSimilarItems_001: 'CURE|MSASI-001',
  matchSaleActionSimilarItems_002: 'CURE|MSASI-002',
  matchSaleActionSimilarItems_003: 'CURE|MSASI-003',
  unmatchSalesAction_001: 'CURE|USA-001',
  unmatchSalesAction_002: 'CURE|USA-002',
  unmatchSalesAction_003: 'CURE|USA-003',
};

export const catalogTarifsError = {
  getCatalogTarifsAction_001: 'CURE|GCI-001',
  getCatalogTarifsAction_002: 'CURE|GCI-002',
  getCatalogTarifsAction_003: 'CURE|GCI-003',
  createTarifAction_001: 'CURE|CTI-001',
  createTarifAction_002: 'CURE|CTI-002',
  updateTarifAction_001: 'CURE|UTI-001',
  updateTarifAction_002: 'CURE|UTI-002',
  updateTarifAction_003: 'CURE|UTI-003',
  deleteTarifAction_001: 'CURE|DTI-001',
  deleteTarifAction_002: 'CURE|DTI-002',
  downloadTarifAction_001: 'CURE|DDTI-001',
  downloadTarifAction_002: 'CURE|DDTI-002',
};

export const changePasswordError = {
  changePassword_1: 'CPE|CP-001',
  changePassword_2: 'CPE|CP-002',
  changePassword_3: 'CPE|CP-003',
};

export const dataIntegrationError = {
  // History
  getUploadsHistory_001: 'DIE|GUH-001',
  handlePaginationAction_001: 'DIE|HPA-001',
  searchOnUploadsHistory_001: 'DIE|SOUH-001',
  // Audiences
  getAudiences_001: 'DIE|GA-001',
  createAudience_001: 'DIE|CA-001',
  createAudience_002: 'DIE|CA-002',
  updateAudience_001: 'DIE|UA-001',
  updateAudience_002: 'DIE|UA-002',
  // Mapping Fields
  getMappingFields_001: 'DIE|GMF-001',
  createMappingField_001: 'DIE|CMF-001',
  createMappingField_002: 'DIE|CMF-002',
  updateMappingField_001: 'DIE|UMF-001',
  updateMappingField_002: 'DIE|UMF-002',
  deleteMappingField_001: 'DIE|DMF-001',
  deleteMappingField_002: 'DIE|DMF-002',
  // Mappings
  getMappings_001: 'DIE|GM-001',
  createMapping_001: 'DIE|CM-001',
  createMapping_002: 'DIE|CM-002',
  deleteMap_001: 'DIE|DM-001',
  deleteMap_002: 'DIE|DM-002',
  // Points of Sale Dictionary
  getPointsOfSaleDictionary_001: 'DIE|GPSD-001',
  createPointsOfSaleDictionary_001: 'DIE|CPSD-001',
  createPointsOfSaleDictionary_002: 'DIE|CPSD-002',
  // File Patterns
  getFilePatterns_001: 'DIE|GFP-001',
  createFilePattern_001: 'DIE|CFP-001',
  createFilePattern_002: 'DIE|CFP-002',
  // Upload files
  uploadFiles_001: 'DIE|UF-001',
  uploadFiles_002: 'DIE|UF-002',
  reprocessImport_001: 'DIE|RI-001',
  reprocessImport_002: 'DIE|RI-002',
  updateInboxFileEncoding_001: 'DIE|UIFE-001',
  updateInboxFileEncoding_002: 'DIE|UIFE-002',
  archiveFileHistory_001: 'DIE|AFH-001',
  archiveFileHistory_002: 'DIE|AFH-002',
};
